import { useCallback } from 'react';
import { useClient } from 'hooks/useClient';
import { useMutation } from 'react-query';
import { ERROR_TOAST_DEFAULTS, SUCCESS_TOAST_DEFAULTS } from '@helpers';
import { useToast } from '@chakra-ui/react';
import { translations } from 'translations';
import { useTranslation } from 'react-i18next';
import { useSession } from 'store/session';
import { AxiosError } from 'axios';
import { getSessionTokenV3 } from 'helpers/sessionContext';


export const useDelete = () => {
  const client = useClient({
    token: getSessionTokenV3() as string,
    url: process.env.REACT_APP_API_V3,
  });

  const toast = useToast();

  const { t } = useTranslation();

  const { team } = useSession();

  const uuid = team?.uuid as string;

  const fn = useCallback(
    async (folder: string) => {
      await client.deleteTeamFolder(uuid, folder);

      const MESSAGE = t(translations.FOLDERS_PAGES.DELETE_SUCCESS);

      toast({ ...SUCCESS_TOAST_DEFAULTS, title: MESSAGE });
    },
    [client, t, toast, uuid],
  );

  const onError = useCallback(
    (error: AxiosError) => {
      let msg = t(translations.ERRORS.NETWORK_DEFAULT);

      if (error?.response?.status === 403) {
        msg = t(translations.ERRORS.PERMISSIONS);
      }

      toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
    },
    [t, toast],
  );

  const mutation = useMutation(['delete-team-folder', uuid], fn, { onError });

  return { ...mutation };
};
